import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Mismo bug ya corregido antes para '/usuarios' (ver customers-access.guard.ts):
// las rutas standalone '/crear-sala' y '/sala/:id' solo tenían authGuard
// (exige sesión), sin verificar el permiso 'spaces' -- el dashboard SÍ lo
// exige para mostrar/permitir la pestaña "Gestión de Salas"
// (ver item.permission en admin-navigation.component.ts), pero un empleado
// sin ese permiso podía saltarse ese control tecleando la URL directamente.
// El backend ya bloqueaba los datos reales (requirePermission('spaces', ...)
// en space.routes.ts), así que no había fuga de información -- pero la
// pantalla quedaba rota/confusa en vez de redirigir con claridad.
export const spacesAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  if (authService.hasPermission('spaces')) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};
